'use client'

import { useEffect, PropsWithChildren } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { PricingRulesModel, viewEvent } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

type Props = {
  priceRules: PricingRulesModel
}

const TrackPageView = ({ children, priceRules }: PropsWithChildren<Props>) => {
  const { track } = useTracking()

  const targetDetails = JSON.stringify({
    campaign_name: priceRules.map(rule => rule.name),
  })

  useEffect(() => {
    track(
      viewEvent({
        screen: 'campaign_landing_page',
        target: 'campaign_landing_page',
        targetDetails,
      }),
    )
  }, [track, targetDetails])

  return children
}

export default TrackPageView
